export const SIZE_DESKTOP = 'desktop';
export const SIZE_MOBILE = 'mobile';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/section-right-many/const.js